module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-cb9db791.png";